import type { Component } from 'solid-js'
import { useTransContext } from '@mbarzda/solid-i18next'
import type { SectionMetrics } from '../../../features/engagement/domain/models/sections'
import { ChartContainerWithHeader, useChart } from '../../shared/charts'
import { getSectionsVisitsBarsOptions } from './SectionsVisitsBars.vm'

interface SectionsVisitsBarsProps {
  sections: SectionMetrics[]
}

const SectionsVisitsBars: Component<SectionsVisitsBarsProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const [t] = useTransContext()

  useChart({
    data: () => props.sections,
    chartRef: () => chartRef,
    buildOptions: (sections) => getSectionsVisitsBarsOptions(sections, t)
  })

  const hasData = () => props.sections.some((s) => s.visits.current > 0)

  return (
    <ChartContainerWithHeader hasData={hasData()} title={t('ls_sections_visits_bars_title')}>
      <div ref={chartRef} />
    </ChartContainerWithHeader>
  )
}

export default SectionsVisitsBars
